import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchUserList = createAsyncThunk("userManagement/fetchUserList", async ({ page, limit, filters }) => {
	const cleanFilters = {};

	if (filters?.keyword) {
		cleanFilters.keyword = filters.keyword;
	}

	if (filters?.role) {
		cleanFilters.role = filters.role;
	}

	if (filters?.email) {
		cleanFilters.email = filters.email;
	}

	const params = new URLSearchParams({
		page: page,
		limit: limit,
		...cleanFilters,
	});

	const response = await axiosHttp.get(`user/list?${params}`);
	return response.data.data;
});

///:id/role
export const updateUserRole = createAsyncThunk("userManagement/updateUserRole", async (data) => {
	const response = await axiosHttp.put(`user/role/update/bulk`, data);
	return response.data.data;
});

const userManagementUserListSlice = createSlice({
	name: "userManagementUserList",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
		currentPage: 1,
		updateRoleSuccess: false,
	},

	reducers: {
		resetStateUserList: (state) => {
			state.isLoading = false;
			state.error = null;
			state.data = null;
			state.updateRoleSuccess = false;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(fetchUserList.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(fetchUserList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.page;
			state.total = action.payload.total;
			state.currentPage = action.payload.current_page;
		});
		builder.addCase(fetchUserList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
			state.page = 1;
			state.total = 0;
			state.currentPage = 1;
		});

		builder.addCase(updateUserRole.pending, (state, action) => {
			state.isLoading = true;
			state.updateRoleSuccess = false;
		});

		builder.addCase(updateUserRole.fulfilled, (state, action) => {
			state.isLoading = false;
			state.updateRoleSuccess = true;
		});

		builder.addCase(updateUserRole.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
			state.updateRoleSuccess = false;
		});
	},
});

export const { resetStateUserList } = userManagementUserListSlice.actions;
export default userManagementUserListSlice.reducer;
